import axios from "axios";
import { config_headers, URL_API, servicelist } from "../Config";

export const pAssessmentScoreInfo = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.assessmentService}p_assessment_score_info`), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const pAssessmentScoreUpdate = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.assessmentService}p_assessment_score_update`), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
